/**
 * Tiny page-side wrappers around the PDF download services.
 *
 * Each handler matches the shape pages were already using:
 *   handler(submissionId[, isActive], setError) → Promise<void>
 *
 * Binder/Policy are gated by `isActive` (issued policies only); COI is
 * always available. Errors are written to the page's local error state
 * via the optional `setError` callback — the caller picks where the
 * message should render.
 */
import {
  downloadBinderPdf,
  downloadCOIPdf,
  downloadPolicyPdf,
} from "@/modules/Payment/api/paymentApi.js";

export async function downloadCOI(submissionId, setError) {
  try { await downloadCOIPdf(submissionId); }
  catch (e) { setError?.(e?.message || "Could not download COI"); }
}

export async function downloadBinder(submissionId, isActive, setError) {
  if (!isActive) return;
  try { await downloadBinderPdf(submissionId); }
  catch (e) { setError?.(e?.message || "Could not download binder"); }
}

export async function downloadPolicy(submissionId, isActive, setError) {
  if (!isActive) return;
  try { await downloadPolicyPdf(submissionId); }
  catch (e) { setError?.(e?.message || "Could not download policy"); }
}
